<template lang='pug'>
v-data-table(:items='schedule' :headers='headers' hide-actions)
  template(slot='items' slot-scope='props')
    tr
      td {{ props.item.object_name }}
      td {{ props.item.start | date('DD MMM YYYY HH:mm') }}
      td {{ props.item.end | date('DD MMM YYYY HH:mm') }}
      td {{ props.item.comment }}
      td(class='crud-tools')
        v-btn(@click='$emit("unassign", props.item)' small flat)
          v-icon(small left) schedule
          | Отменить запись
</template>

<script>
export default {
  props: ['schedule'],

  data: () => ({
    headers: [
      {
        text: 'Объект',
        sortable: false
      },
      {
        text: 'Время начала осмотра',
        sortable: false
      },
      {
        text: 'Время завершения осмотра',
        sortable: false
      },
      {
        text: 'Комментарий',
        sortable: false
      },
      {
        text: '',
        sortable: false,
        class: 'crud-tools'
      }
    ]
  })
}
</script>

